import React, { useEffect, useState } from "react";
import useStyles from "../../../components/common/model/styles";
import Popup from "../../../components/common/model/Popup";
import {
  Alert,
  DialogContent,
  DialogContentText,
  TextField,
} from "@mui/material";
import closeIcon from "../../../assets/closeModel.png";
import CustomButton from "../../../components/common/button/CustomButton";
import { useDispatch } from "react-redux";

import Notification from "../../../components/common/notification/Notification";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import { paymentDeletedAction } from "../../../store/reducers/paymentSlice";

interface InvoiceAlertActionPopupProps {
  title?: string;
  open?: boolean;
  selectedPaymentId?: any;
  onHide?: () => void;
  clientDetails?: any;
  alertModalShow: boolean;
  setAlertModelShow: (show: boolean) => void;
  setShowSuccessMessage?: (message: string) => void;
  resetAllValidator?: any;
  setIsClickReset?: any;
  message?: string;
  onSubmit?: () => void;
}
const InvoiceAlertAction: React.FC<InvoiceAlertActionPopupProps> = ({
  onHide,
  alertModalShow,
  setAlertModelShow,
  setIsClickReset,
  selectedPaymentId = "",
  title,
  onSubmit,
  message,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  useEffect(() => {
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  }, []);
  const closeModel = () => {
    setAlertModelShow(false);
    dispatch(setNotificationAction({ message: [], severity: "info" }));
    if (onHide) onHide();
  };

  return (
    <Popup
      open={alertModalShow}
      title={"Alert"}
      onHide={closeModel}
      fullWidth={true}
      maxWidth={"xs"}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          <CustomButton variant="outlined" title="No" onClick={closeModel} />
          <CustomButton title="Yes" onClick={onSubmit} />
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          <Notification />
          <Alert
            sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
            severity="warning"
          >
            {message}
          </Alert>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default InvoiceAlertAction;
